import { Component } from '@angular/core';
import { Platform } from '@ionic/angular';
import { LocalNotifications } from '@capacitor/local-notifications';
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';
import { register } from 'swiper/element/bundle';
import { NewRelicService } from 'src/shared/newrelic.service';
import { EdgeToEdge } from '@capawesome/capacitor-android-edge-to-edge-support';
register();

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html'
})
export class AppComponent {
  constructor(
    private platform: Platform,
    private newRelicservice: NewRelicService

  ) {
    this.initializeApp();
  }

  initializeApp() {
    StatusBar.setOverlaysWebView({ overlay: false });
    this.platform.ready().then(async () => {
      if (Capacitor.getPlatform() === 'ios' || Capacitor.getPlatform() === 'android') {
        //this.newRelicservice.init();
        if (Capacitor.getPlatform() === 'android') {
          await EdgeToEdge.enable(); // optional – plugin already applies insets by default
        }
        StatusBar.setOverlaysWebView({ overlay: false });
        StatusBar.setStyle({ style: Style.Default });
        const permissionStatus = await LocalNotifications.checkPermissions();

        if (permissionStatus.display === 'granted') {
          console.log('Notification permission granted');
        } else if (permissionStatus.display === 'prompt' || permissionStatus.display === 'denied') {
          // If permission is not granted, request it
          const requestStatus = await LocalNotifications.requestPermissions();

          if (requestStatus.display === 'granted') {
            console.log('Notification permission granted after request');
          } else {
            console.log('Notification permission denied');
          }
        }
        setTimeout(() => { SplashScreen.hide(); }, 500);
      }
    });
  }
}
